
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/campaigns",
      function () {
        return require("private-next-pages/admin/campaigns.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/campaigns"])
      });
    }
  